import React from 'react'
import headerimg from '../assets/OWRB header.png'
import Videobtn from '../assets/Button - Video.png'
import Twobtn from '../assets/2.png'
import Robertbtn from '../assets/Button - Kerr.png'
import AddiResource from '../components/AddiResource';
import RobertSKerrpdf from '../assets/pdf/RobertSKerr.pdf'

export default function RobertSKerr() {
    return (
        <div>

            <main className="flex-shrink-0 modular min-vh-100 mt-5">


                <img className='my-5' style={{ maxWidth: "100%" }} src={headerimg} />

                <div className="container mt-2">
                    <div className='row'>
                        <div className='col-1 d-none d-lg-block'></div>
                        <div className='col-12 col-lg-10'>

                            <div className="row">

                                <div className="col-md-4 col-lg-2">
                                    <div className="row" style={{ paddingBottom: "10px" }}>
                                        <a href={RobertSKerrpdf} without rel="noopener noreferrer" target="_blank"><img src={Twobtn}
                                            style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                    <div className="row text-center" style={{ paddingBottom: "10px" }}>
                                        <a href="https://vimeo.com/503096608/c2e637fbe7" target="_blank"><img
                                            src={Videobtn} height="150" width="150"
                                            style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                    <div className="row" style={{ paddingBottom: "10px" }}>
                                        <a href="https://kerr.metroquest.com/" target="_blank"><img src={Robertbtn}
                                            style={{ maxWidth: "100%" }} /></a>
                                    </div>
                                </div>
                                <div className="col-md-8 col-lg-10">
                                    <div className="container" style={{ minHeight: "400px" }}>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <h1>Robert S. Kerr Reservoir</h1>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>The Robert S. Kerr Reservoir watershed is approximately 1,760 square miles and is
                                                    in the southeast quadrant of Oklahoma and is centered around the town of
                                                    Sallisaw. The watershed includes over 40 miles of Interstate 40 and includes a
                                                    portion of the state of Arkansas. The Robert S. Kerr Reservoir dams up the
                                                    Arkansas River just south of Sallisaw and the Arkansas River then continues to
                                                    drain easterly towards Fort Smith and Van Buren, Arkansas.</p>
                                                <p>The watershed contains 26 communities, 20 of which participate in the National
                                                    Flood Insurance Program (NFIP), and includes the counties of Adair, Cherokee,
                                                    Haskell, Latimer, Le Flore, Pittsburg, Sequoyah, and Washington.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col" style={{ textAlign: "start" }}>
                                                <p>On the left side of this screen, you will find two round blue buttons that you
                                                    can click on. The top button links to a Tutorial Video which explains how to
                                                    take the online interactive survey about your watershed. The lower button will
                                                    take you to the actual survey.</p>
                                                <p>At the bottom of the screen, you will find a slew of additional free resources
                                                    that cover topics such as Risk Mapping, National Flood Insurance Program, Dam
                                                    Safety, Hazard Mitigation Assistance Grants, a link to Oklahoma Water Resource
                                                    Board, and much more.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='col-1'></div>
                    </div>
                </div>
            </main>
            <AddiResource />
        </div>
    )
}
